import React, { useState , useEffect } from "react";
import Preview from "./componets/preview";
import Message from "./componets/Message";
import NotesContiner from "./componets/NotesSection/NoteContiner";
import NotesList from "./componets/NotesSection/NotesList";
import Note from "./componets/NotesSection/note";
import Alert from "./componets/Alert";
import "./style.css";
import './normalize.css';


function App() {
  // all usestate
  const [creating , setCreating]=useState(false);
  const [title, setTitle]=useState("");
  const [content, setContent]=useState("");
  const [notes,setNotes]=useState([]);
  const [selectNote ,setSelectNote]=useState(null);
  const [editing ,setediting]=useState(false);
  const [valdtionError,setvaldtionError]=useState([]);
  // localstorage
  useEffect(()=>{
    if(localStorage.getItem("notes")){
      setNotes(JSON.parse(localStorage.getItem("notes")));
    }else{
      localStorage.setItem("notes",JSON.stringify([]));
    }
  },[]);

  useEffect(()=>{
    if(valdtionError.length !== 0){
      setTimeout(()=>{
        setvaldtionError([])
       },3000)
    }
  })

  const saveToLocalstorage=(key ,value)=>{
    localStorage.setItem(key,JSON.stringify(value));
  }
  const valid=()=>{
    const valdtionError=[];
    let pass=true;
    if(!title){
      valdtionError.push("الرجاء ادخال عنوان الملاحضة ");
      pass=false;
    }
    if(!content){
      valdtionError.push("الرجاء ادخال محتوى الملاحضة ");
      pass=false;
    }
    setvaldtionError(valdtionError);
    return pass;
  }
  // change title
  const changeTitleHand=(event)=>{
    setTitle(event.target.value);
  }
  // change content 
  const changeContentHand=(evevt)=>{
    setContent(evevt.target.value);
  }
  // save new note
  const saveNoteHand=()=>{
    if(!valid()) return;
    const note={
      id:new Date(),
      title:title,
      content:content
    }
    const updateNote=[...notes,note];
    saveToLocalstorage("notes",updateNote);
    setNotes(updateNote);
    setCreating(false);
    setTitle("");
    setContent("");
    setSelectNote(note.id);
  }
  // select note
  const selectNotesHandler = noteId =>{
    setSelectNote(noteId);
    setCreating(false);
    setediting(false);
  }
  // تعديل ملاحضة
  const editNoteHand =()=>{
    if(!valid()) return;
    const note=notes.find(note => note.id === selectNote)
    setediting(true);
    setTitle(note.title);
    setContent(note.content);
  }
  const updateNoteHand =()=>{
    const updatenotes=[...notes];
    const updateIndex=notes.findIndex(note => note.id===selectNote)
    updatenotes[updateIndex]={
      id:selectNote,
      title:title,
      content:content
    };
    saveToLocalstorage("notes",updatenotes);
    setNotes(updatenotes);
    setediting(false);
    setTitle("");
    setContent("");

  }
  // delete note
  const deletNoteHand =()=>{
    const deletNote=[...notes];
    const deletIndex=deletNote.findIndex(note => note.id === selectNote);
    notes.splice (deletIndex , 1 );
    saveToLocalstorage("notes",notes);
    setNotes(notes);
    setSelectNote(null);
  }
    // create note
    const handCreatingNote=()=>{
      setCreating(true);
      setediting(false);
      setTitle("");
      setContent("");
  
    }
  // add new note
  const getAddNote=()=>{
    return(
    <div className="add-note">
      <h3>اضافة ملاحضة جديدة</h3>
      <input
       type="text"
        placeholder="العنوان"
        name="title"
        className="title-note"
        value={title}
        onChange={changeTitleHand}
        ></input>
      <textarea
       placeholder="المحتوى"
       row="10"
       className="content-note"
       name="content"
       value={content}
       onChange={changeContentHand}
       ></textarea>
      <button 
       className="save-note"
       onClick={saveNoteHand} >save</button>
    </div>
    )
  }
    // view note
  const getPreview =()=>{
    if(notes.length===0){
      return <Message title="لايوجد ملاحضة"></Message>
    }
    if(!selectNote){
      return <Message title="الرجاء اختيار ملاحضة"></Message>
    }
    const note = notes.find(note=>{
      return note.id === selectNote;
    })

    let noteDisplay =(
      <div>
      <h2>{note.title}</h2>
      <p>{note.content}</p>
      </div>
    )
    if(editing){
      noteDisplay=(
        <div className="add-note">
          <h2>تعديل ملاحضة</h2>
          <input
       type="text"
        placeholder="العنوان"
        name="title"
        className="title-note"
        value={title}
        onChange={changeTitleHand}
        ></input>
      <textarea
       placeholder="المحتوى"
       row="10"
       className="content-note"
       name="content"
       value={content}
       onChange={changeContentHand}
       ></textarea>
      <button 
       className="save-note"
       onClick={updateNoteHand} >تعديل</button>
        </div>
      )
    }
    return(
      <div className="preview-note">
        {noteDisplay}
        {!editing &&
        <div>
          <button onClick={editNoteHand}>تعديل</button>
          <button onClick={deletNoteHand}>حذف</button>
        </div>
  }
  </div>
    )
  }

  

  return (
    <div>
    <div className="logo">note
    </div>
    <div className="app">
      <NotesContiner>
        <NotesList>
        {notes.map(note => 
        <Note key={note.id}
         title={note.title}
         notesClicked={()=> selectNotesHandler(note.id)}
         active={selectNote === note.id}/>
         )}  
        </NotesList>
        <button onClick={handCreatingNote}>+</button>
      </NotesContiner>
      <Preview>
        {creating ? getAddNote() : getPreview()}
      </Preview>
      {valdtionError.length !==0 && <Alert titleError={valdtionError[0]} contentError={valdtionError[1]}/>}
    </div>
    </div>
  )
}

export default App;
